import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the job-scheduler workspace component
registerWorkspaceComponent(
  'job-scheduler',
  lazyWorkspaceTab(() => import('./components/JobSchedulerTab').then((m) => ({ default: m.JobSchedulerTab }))),
);

